<app-link [route]="route" (click)="clickOnItem($event)" type="none"
          color="dark" #link>
  <div class="flex items-center gap-3 px-3 py-2 rounded-xl transition-all cursor-pointer"
       [ngClass]="{
            'bg-surface-accent text-primary font-bold': active,
            'text-on-surface-variant hover:bg-surface-container-low font-medium': !active
        }">
     <div class="text-lg flex items-center shrink-0" [ngClass]="{ 'text-primary': active }">
      <ng-content select="[icon]"></ng-content>
    </div>
    <div class="empty:hidden min-w-0 text-sm leading-snug"
         [ngClass]="{
            'ml-2': margin === 'ml-2',
            'ml-0': margin === 'ml-4'
         }">
      <ng-content select="[text]"></ng-content>
    </div>
     <div *ngIf="active" class="ml-auto w-1 h-6 bg-primary rounded-full"></div>
  </div>
</app-link>
